// src/App_intro.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import IntroLogo from "./components/IntroLogo";
import Nospartenaires from "./components/Nospartenaires";

const App_intro = () => {
  const [showNospartenaires, setShowNospartenaires] = useState(false);
  const navigate = useNavigate();

  const handleIntroFinish = () => {
    setShowNospartenaires(true);
  };

  const handleAccessPlatform = () => {
    navigate('/home');
  };

  return (
    <div className="min-h-screen bg-white">
      {!showNospartenaires ? (
        <IntroLogo onFinish={handleIntroFinish} />
      ) : (
        <Nospartenaires onFinish={handleAccessPlatform} />
      )}
    </div>
  );
};

export default App_intro;
